import React from "react"
import { DecorItemInforLayout } from "../../layouts/nesta_decor/decor_item_info_layout"
export const DecorItemInfo =(props)=>{
    return(<DecorItemInforLayout decorItem = {props.decorItem}/>)
}

